<template>
	<div>404</div>
</template>

<script>
export default {
	setup() {
		return {};
	},
};
</script>
